import { Dropdown } from 'components/Dropdown';
import { useEditFlowProperties } from '../useEditFlowProperties';
import type { FlowPropertiesProps } from '../withFlowProperties';

type Props = FlowPropertiesProps;

const PortDropdown = ({ id, activeUnit, flowProperties }: Props) => {
  const { outputPorts, inputPorts, currentPort, isStorage, setValue } =
    useEditFlowProperties(id, activeUnit, flowProperties);

  const ports = isStorage ? inputPorts : outputPorts;

  return (
    <Dropdown
      value={currentPort?.name ?? ''}
      setValue={(val) => {
        const newPort = ports?.find((port) => port.name === val);
        if (typeof newPort?.portIndex !== 'undefined') {
          setValue('activePortIndex', newPort.portIndex - 1);
        }
      }}
      dropDownOptions={ports.map((p) => p.name)}
      label={isStorage ? 'Input' : 'Output'}
    />
  );
};

export default PortDropdown;
